<template>
    <div class="w-full md:w-64 rounded p-3 shadow bg-white text-black-50 m-1 leading-normal">
        <h3 class="font-semibold my-2 flex">
            <icon name="location" class="inline w-4 mr-3" />
            {{ $page.props.locations[address.location] }}
        </h3>
        <p v-if="address.location !== $page.props.vessel_key" class="text-sm">{{ address.address }}</p>
        <p v-if="address.location === $page.props.vessel_key" class="text-sm">{{ address.vessel_details }}</p>
        <p v-if="address.location === $page.props.vessel_key" class="text-sm">{{ address.vessel_location }}</p>
        <p class="text-sm mt-3">
            <a :href="`tel:+${ address.contact_number }`">
                <icon name="phone-call" class="inline w-6 text-black-50" />
                {{ address.contact_number }}
            </a>
        </p>
    </div>
</template>

<script>
  import Icon from '@/Shared/Icon'
  export default {
    name: 'DeliveryAddressCard',
    components: {
      Icon
    },
    props: {
      address: Object
    }
  }
</script>

<style scoped>

</style>
